import{a as t}from"./chunk-SFHV6FUY.js";import{jsx as o}from"react/jsx-runtime";function n({className:e,...r}){return o("div",{className:t("animate-pulse rounded-md bg-neutral-400 dark:bg-neutral-800",e),...r})}export{n as a};
